import cx from 'clsx';

import { Text } from '@manage-cards/constants';
import { CardDeleteStatus } from '@manage-cards/types';

import { Loader, Button, Image, Overlay } from '@shared/components/core';

import errorIcon from '@assets/icons/errorIcon.svg';
import successIcon from '@assets/icons/check-green.svg';

import styles from './ConfirmModal.module.scss';

interface IConfirmModalProps {
	status: CardDeleteStatus;
	handleCancel: () => void;
	handleConfirm: () => void;
}

const ConfirmModal = ({
	status,
	handleConfirm,
	handleCancel,
}: IConfirmModalProps) => {
	const renderOverlayContent = () => {
		switch (status) {
			case CardDeleteStatus.SUCCESS:
				return (
					<>
						<div className="center px6">
							<Image
								src={successIcon}
								alt="success icon"
								height={66}
								width={66}
								className="mt3"
							/>
							<h2 className="h4 bold dark1 px4 center mt1 mb6">
								{Text.CARD_DELETED_SUCCESS_TITLE}
							</h2>
						</div>
						<Button
							className="width100"
							variant="primary"
							onClick={handleCancel}
						>
							{Text.OKAY}
						</Button>
					</>
				);
			case CardDeleteStatus.FAILURE:
				return (
					<>
						<div className="center px6">
							<Image
								src={errorIcon}
								alt="error icon"
								height={40}
								width={40}
								className="mt3"
							/>
							<h2 className="h4 bold dark1 center mb2">
								{Text.CARD_DELETED_FAILURE_TITLE}
							</h2>
							<p className="h5 lighter dark2 px5 center mt2 mb6">
								{Text.CARD_DELETED_FAILURE_DESCRIPTION}
							</p>
						</div>
						<Button
							className="width100"
							variant="primary"
							onClick={handleConfirm}
						>
							{Text.TRY_AGAIN}
						</Button>
					</>
				);
			case CardDeleteStatus.INPROGRESS:
				return (
					<>
						<Loader className={styles.loader} height="30px" width="68px" />
						<h2 className="h4 bold dark1 center">{Text.DELETING_YOUR_CARD}</h2>
						<p className="h5 lighter dark2 px6 center">
							{Text.DELETING_CARD_DESCRIPTION}
						</p>
					</>
				);
			default:
				return (
					<>
						<div className="center px6">
							<Image
								src={errorIcon}
								alt="error icon"
								height={40}
								width={40}
								className="mt3"
							/>
							<h2 className="h4 bold dark1 p4 center mt0">
								{Text.CONFIRM_DELETE_TITLE}
							</h2>
						</div>
						<div className="d-flex justify-center gap4">
							<Button
								className="width100"
								variant="secondary"
								onClick={handleCancel}
							>
								{Text.CANCEL}
							</Button>
							<Button
								className="width100"
								variant="primary"
								onClick={handleConfirm}
							>
								{Text.DELETE_CARD}
							</Button>
						</div>
					</>
				);
		}
	};

	return (
		<Overlay isOpen onClose={handleCancel} handleMobileResolution={false}>
			<div
				className={cx(
					'p4 bg-white border-radius3',
					styles.confirmModalContainer,
				)}
			>
				{renderOverlayContent()}
			</div>
		</Overlay>
	);
};

export default ConfirmModal;
